
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/contact-us",
      function () {
        return require("private-next-pages/[lang]/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/contact-us"])
      });
    }
  